import getPitch from './pitch-detection';
import p5 from 'p5';
import 'p5/lib/addons/p5.sound';
import 'p5/lib/addons/p5.dom';

export default function sketch(p) {
  let source, fft, lowPass;
  let amplitude;
  let noteName;
  let targetFrequency;

  function frequencyToColor(freq) {
    const COLORS = [
      '#FF0001',
      '#FF4401',
      '#D66F01',
      '#FFC503',
      '#E0EA03',
      '#76D102',
      '#01FFAB',
      '#00FFE7',
      '#00B2FF',
      '#3409FF',
      '#9E07FF',
      '#FF03FD',
    ];
    const NOTE_FREQUENCIES = [
      16.35,
      17.32,
      18.35,
      19.45,
      20.6,
      21.83,
      23.12,
      24.5,
      25.96,
      27.5,
      29.14,
      30.87,
    ];
    let i = 0;
    let j = 0;
    while (i < 200) {
      NOTE_FREQUENCIES.push(NOTE_FREQUENCIES[j] * 2);
      j++;
      i++;
    }
    const NOTES = [
      'C',
      'C#',
      'D',
      'D#',
      'E',
      'F',
      'F#',
      'G',
      'G#',
      'A',
      'A#',
      'B',
    ];

    const level = amplitude.getLevel();
    if (level < 0.001) {
      return 'black';
    }

    // const nfreq = normalizeToFit(NOTE_FREQUENCIES, freq);
    p.fill(0);
    // text ('Estimated Low Frequency: ' + nfreq.toFixed(2), 20, 20);
    const note = findClosest(NOTE_FREQUENCIES, freq);
    const index = NOTE_FREQUENCIES.indexOf(note);
    const nindex = index % COLORS.length;
    const color = COLORS[nindex];
    noteName = NOTES[nindex];
    targetFrequency = note;

    return color;
  }

  function findClosest(arr, value) {
    const distances = arr.map(v => Math.abs(v - value));
    const mindist = p.min(distances);
    return arr[distances.indexOf(mindist)];
  }

  function colorAlpha(aColor, alpha) {
    var c = p.color(aColor);
    return p.color(
      'rgba(' + [p.red(c), p.green(c), p.blue(c), alpha].join(',') + ')',
    );
  }

  p.myCustomRedrawAccordingToNewPropsHandler = function myCustomRedrawAccordingToNewPropsHandler(
    props,
  ) {};

  p.setup = function setup() {
    console.log('creating canvas');
    p.createCanvas(p.windowWidth, p.windowHeight);
    p.noFill();

    // uncomment me to use mic
    source = new p5.AudioIn();
    source.start();

    // source.play(); // comment me to use mic

    amplitude = new p5.Amplitude();
    amplitude.setInput(source);

    lowPass = new p5.LowPass();
    lowPass.disconnect();
    source.connect(lowPass);

    fft = new p5.FFT();
    fft.setInput(lowPass);

    p.background(255);

    // const squareBrushButton = p5.createButton('Square Brush');
    // squareBrushButton.position(p.width - 100, p.height - 20);
    // squareBrushButton.mousePressed(() => (brush = squareBrush));
    // const circleBrushButton = p5.createButton('Circle Brush');
    // circleBrushButton.position(p.width - 100, p.height - 40);
    // circleBrushButton.mousePressed(() => (brush = circleBrush));
  };

  p.draw = function draw() {
    p.noFill();

    const timeDomain = fft.waveform(1024, 'float32');
    const freq = getPitch(p, timeDomain);
    const spectrumColor = frequencyToColor(freq);
    const level = amplitude.getLevel();

    p.background(colorAlpha(spectrumColor, 0.3 * (0.05 + level)));

    p.onChange && p.onChange({
      frequency: freq,
      spectrumColor,
      targetFrequency,
      noteName,
      level,
    });
  };

  p.touchStarted = function touchStarted() {
    p.getAudioContext().resume();
  };
}



// WEBPACK FOOTER //
// ./src/sketches/full-background-sketch.js